import { useState } from "react";
import { Frame, Detail } from "@/components/diagrams/kit";
import { Slider } from "@/components/ui/slider";

const FACTORS = [
  ["availability", "Availability", "Breakdowns · changeovers · waiting", "Which stops grew, on which machine, in which shift?"],
  ["performance", "Performance", "Micro-stops · reduced speed", "Are micro-stops concentrated on one asset? Check quality flags on speed tags."],
  ["quality", "Quality", "Scrap · rework · start-up rejects", "Which batch or changeover produced the rejects?"],
];

export default function OeeCalculator() {
  const [v, setV] = useState({ availability: 88, performance: 86, quality: 95 });
  const oee = (v.availability * v.performance * v.quality) / 10000;
  const worst = FACTORS.reduce((a, b) => (v[b[0]] < v[a[0]] ? b : a));
  return (
    <Frame title="OEE as a decision system" hint="Move the losses" testId="diagram-oee">
      <div className="grid gap-6 lg:grid-cols-[200px_1fr]">
        <div className="flex flex-col items-center justify-center border border-trust bg-trust p-6 text-white">
          <div className="font-mono text-[11px] uppercase tracking-widest text-white/60">OEE</div>
          <div data-testid="oee-value" className="font-heading text-5xl font-black">{oee.toFixed(1)}%</div>
          <div className="mt-1 text-center text-[11px] text-white/60">A × P × Q</div>
        </div>
        <div className="space-y-5">
          {FACTORS.map(([k, label, losses]) => (
            <div key={k} className={`border p-3 ${worst[0] === k ? "border-brand-action bg-brand-action/10" : "border-border bg-card"}`}>
              <div className="flex justify-between text-sm"><span className="font-semibold">{label} <span className="font-normal text-muted-foreground">— {losses}</span></span><span className="font-mono">{v[k]}%</span></div>
              <Slider data-testid={`oee-slider-${k}`} className="mt-3" min={50} max={100} step={1} value={[v[k]]} onValueChange={([n]) => setV({ ...v, [k]: n })} aria-label={label} />
            </div>
          ))}
        </div>
      </div>
      <Detail testId="oee-detail">
        <span key={worst[0]}><strong>Biggest loss: {worst[1]}.</strong> Don’t stop at “OEE was {oee.toFixed(0)}%”. Next drill-down: {worst[3]} State the line, time period, calculation definition and data quality.</span>
      </Detail>
    </Frame>
  );
}
